<template>
    <label :for="forElement" :aria-label="getAriaLabel()" :class="optionalLabelClass">

        <!-- Checkbox label with a read more placeholder -->
        <template v-if="hasReadMore">

            <!-- Render caption before the read more marker -->
            <template v-for="(captionPart, j) in getShortCaptionArray">
                <button v-if="isPlaceholder(captionPart)" type="button" tabindex="-1" class="ciam-legal-link-button"
                        :id="'link-legalText-' + getLegalTextId(captionPart) + '-' + _uid"
                        @click.prevent="onClick(getLegalTextId(captionPart))" :key="'legalTextButton-' + j + '-' + _uid">
                    {{ getLegalTextTitle(captionPart) }}
                </button>
                <span v-else class="legalTextContent" :key="'legalTextContent-' + j">{{captionPart}}</span>
            </template>

            <!-- Render caption after the read more marker -->
            <div :id="'legal-text-label-' + _uid + '-read-more'" :class="_uid + '-read-more-content'" style="display: none;">
                <template v-for="(readMoreCaptionPart, i) in getReadMoreCaptionArray">
                    <span v-if="!isPlaceholder(readMoreCaptionPart)" class="legalTextContent" :key="'legalTextContent-' + i">{{readMoreCaptionPart}}</span>
                    <button type="button" tabindex="-1" v-else class="ciam-legal-link-button"
                            :id="'link-legalText-' + getLegalTextId(readMoreCaptionPart) + '-' + _uid"
                            @click.prevent="onClick(getLegalTextId(readMoreCaptionPart))" :key="'legalTextButton-' + i + '-' + _uid">
                        {{ getLegalTextTitle(readMoreCaptionPart) }}
                    </button>
                </template>
            </div>
            <template v-if="consentRequired"><strong> * </strong></template>
            <a class="ciam-legal-link-button" @click.prevent="toggleReadMore">
                {{isReadMoreDisplayed ? '[' + $t('components.toas.readMoreClose') + ']' : '[' + $t('components.toas.readMoreOpen') + ']'}}
            </a>
        </template>

        <!-- Normal checkbox label -->
        <template v-else>
            <template v-for="(captionPart, j) in getCaptionArray">
                <span v-if="!isPlaceholder(captionPart)" class="legalTextContent" :key="'legalTextContent-' + j">{{captionPart}}</span>
                <button type="button" tabindex="-1" v-else class="ciam-legal-link-button"
                        :id="'link-legalText-' + getLegalTextId(captionPart) + '-' + _uid"
                        @click.prevent="onClick(getLegalTextId(captionPart))" :key="'legalTextButton-' + j + '-' + _uid">
                    {{ getLegalTextTitle(captionPart) }}
                </button>
            </template>
            <template v-if="consentRequired"><strong> *</strong></template>
        </template>
    </label>
</template>

<script>

export default {
  data: function () {
    return {
      isReadMoreDisplayed: false,
      readMoreSeparator: '{rm}'
    }
  },
  props: {
    // ID of the element this label belongs to
    forElement: {
      type: String,
      default: ''
    },
    // Text to display next to the checkbox (contains the placeholders, e.g. {0})
    caption: {
      type: String,
      default: ''
    },
    // If checking this checkbox is mandatory for continuing (only to display the mandatory sign)
    consentRequired: {
      type: Boolean,
      default: false
    },
    // The legal texts associated with this checkbox (a text consists of a title and an ID)
    texts: {
      type: Array,
      default: () => []
    },
    // Title of the consent item
    title: {
      type: String,
      default: ''
    },
    // Id of the consent item
    id: {
      type: Number,
      default: 0
    },
    // The function that is to be called when pressing a link in the checkbox text
    onClick: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    toggleReadMore: function () {
      const elem = document.getElementById('legal-text-label-' + this._uid + '-read-more')

      if (!elem) return

      elem.style.display = elem.style.display === 'none' ? 'contents' : 'none'
      this.isReadMoreDisplayed = this.isReadMoreDisplayed !== true
    },
    getLegalTextId: function (indexString) {
      if (this.id !== 0) {
        return this.id
      }
      return this.texts[parseInt(indexString)].id
    },
    getLegalTextTitle: function (indexString) {
      if (this.title !== '') {
        return this.title
      }
      return this.texts[parseInt(indexString)].title
    },
    isPlaceholder: function (content) {
      return /^([0-9]+)$/.test(content)
    },
    getAriaLabel: function () {
      let raw = this.caption

      if (this.hasReadMore) raw = raw.replace(this.readMoreSeparator, '')

      raw = raw.split(new RegExp('({[0-9]})'))

      let j = 0
      for (let i = 0; i < raw.length; i++) {
        if (i % 2 === 1) {
          if (this.title !== '') {
            raw[i] = this.title
          } else {
            raw[i] = this.texts[j].title
          }
          j++
        }
      }

      return raw.join('')
    }
  },
  computed: {
    hasReadMore: function () {
      return this.caption.includes(this.readMoreSeparator)
    },
    getCaptionArray: function () {
      return this.caption.split(/[{}]+/)
    },
    getShortCaptionArray: function () {
      return this.caption.split(this.readMoreSeparator)[0].split(/[{}]+/)
    },
    getReadMoreCaptionArray: function () {
      return this.caption.split(this.readMoreSeparator)[1].split(/[{}]+/)
    },
    optionalLabelClass: function () {
      return this.consentRequired === false ? 'ciam-legal-text-label--optional' : ''
    }
  }
}
</script>
<style>
    .legalTextContent {
        cursor: default;
    }
</style>
